import type { TOC } from '@ember/component/template-only';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import ConfirmationCheckIcon from 'tio-ui/components/confirmation-check-icon';
import ManagePage from 'tio-employee/components/tas/applications/manage/manage-page';
import type { ManageFixture } from 'tio-employee/utils/tas/manage-fixtures';

interface GallerySignature {
  Args: { model: ManageFixture[] };
}

// Dev-only showcase route — labels are intentionally bare (not localized).
const ManageGallery: TOC<GallerySignature> = <template>
  {{! template-lint-disable no-bare-strings }}
  <VStack>
    <PageHeader
      @title="Manage screen — state gallery"
      @subtitle="Dev-only preview of every manage / Needs Your Attention state from fixtures (flag + non-prod gated)."
    />

    {{! Standalone preview of the reusable animated confirmation icon — not
      wired into a real notification yet, just for visual QA against the
      Figma "Confirmation Specs" bounce-in animation. Reload the page (or
      re-visit the route) to replay it. }}
    <div class="tio-col gap-3">
      <div class="tio-row flex-wrap gap-2 border-b tio-border-default pb-1">
        <span class="tio-text-xs-semibold tio-fg-info uppercase">confirmation-check-icon</span>
        <span class="tio-text-sm-medium tio-fg-secondary">Reusable animated icon (reload to replay)</span>
      </div>
      <div
        class="tio-bg-sunken tio-row items-center gap-4 rounded-2xl border tio-border-default p-4"
      >
        <ConfirmationCheckIcon />
        <span class="tio-text-sm-normal tio-fg-secondary">
          bounces in once on mount — timing lives in animations.css's
          --tio-confirmation-check-duration, not hardcoded here
        </span>
      </div>
    </div>

    {{#each @model as |fixture|}}
      <div class="tio-col gap-3">
        <div class="tio-row flex-wrap gap-2 border-b tio-border-default pb-1">
          <span class="tio-text-xs-semibold tio-fg-info uppercase">{{fixture.key}}</span>
          <span class="tio-text-sm-medium tio-fg-secondary">{{fixture.label}}</span>
        </div>
        <div class="tio-bg-sunken rounded-2xl border tio-border-default p-4">
          <ManagePage @application={{fixture.application}} />
        </div>
      </div>
    {{/each}}
  </VStack>
</template>;

export default ManageGallery;
